import React from 'react'

function Header(props) {
  return (
    <div className='header'>
      <h1>My Travel Bucket List</h1>
    </div>
  )
}

export default Header
